'use client';

import { useNuqsNextAppRouterAdapter } from '../../chunk-C3RNEY2H.js';
import { createAdapterProvider } from '../../chunk-5WWTJYGR.js';

// src/adapters/next/app.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextAppRouterAdapter);

export { NuqsAdapter };
